import { Filter } from 'module/types/filter-field/filter';
import { Loading } from 'module/ui/components/atoms/loading';
import { CustomOption } from 'module/ui/components/atoms/select';
import { Typography, Divider as AntdDivider, Space } from 'antd';
import styled from 'styled-components';
import { PlaceholderValues } from './placeholder-values';
import { SelectedValues } from './selected-values';
import { ConditionTypes } from './types';

export const BlockSpace = styled(Space)`
  width: 100%;
`;

const { Text } = Typography;

export const PlaceholderText = styled(Text).attrs({ type: 'secondary' })`
  color: var(--gray-50);
`;

export const Divider = styled(AntdDivider)`
  margin: 0;
`;

export const Content = ({
  contentFor,
  salesforceObject,
  selectedConditions,
  loading,
}: {
  loading?: boolean;
  contentFor: ConditionTypes;
  salesforceObject?: CustomOption;
  selectedConditions?: Filter;
}) => {
  if (loading) {
    return <Loading />;
  }

  switch (true) {
    case Boolean(selectedConditions): {
      if (selectedConditions?.criteria?.length) {
        return (
          <BlockSpace direction="vertical" size={16}>
            <SelectedValues
              selectedCondition={selectedConditions}
              showType={contentFor === ConditionTypes.Matches}
              customOptionTrigger={contentFor !== ConditionTypes.Matches}
            />
          </BlockSpace>
        );
      }

      return (
        <PlaceholderValues
          placeholderFor={contentFor}
          disabled={salesforceObject == null}
          onVisibilityChange={() => {}}
        />
      );
    }

    default: {
      return (
        <PlaceholderValues
          placeholderFor={contentFor}
          disabled={salesforceObject == null}
          onVisibilityChange={() => {}}
        />
      );
    }
  }
};
